import * as Yup from 'yup';
import { IActionvationPreferenceForm } from 'core/interface/activation';
import { TFunction } from 'i18next';

const initialValues: IActionvationPreferenceForm = {
  availability: '',
  willing_to_move: '',
  work_exp: '',
  expect_per_month: '',
  hourly_rate: '',
  management_exp: '',
  interests: [],
  work_hours: '',
  contract: [],
  industries: [],
  location: {
    display_name: '',
    id: -1
  },
  remote_only: false
};

const validationSchema = (t: TFunction) => {
  return Yup.object({
    availability: Yup.string()
      .required(t('required'))
      .notOneOf(['null'])
      .nullable(),
    work_hours: Yup.string()
      .required(t('required'))
      .notOneOf(['null'])
      .nullable(),
    willing_to_move: Yup.string()
      .required(t('required'))
      .notOneOf(['null'])
      .nullable(),
    work_exp: Yup.string()
      .required(t('required'))
      .notOneOf(['null'])
      .nullable(),
    management_exp: Yup.string()
      .required(t('required'))
      .notOneOf(['null'])
      .nullable(),
    expect_per_month: Yup.string().when('contract', {
      is: (contract: number[]) =>
        contract && (contract.includes(1) || contract.includes(3)),
      then: (schema) =>
        schema.required(t('required')).notOneOf(['null']).nullable(),
      otherwise: (schema) => schema.nullable()
    }),
    hourly_rate: Yup.string().when('contract', {
      is: (contract: number[]) => contract && contract.includes(2),
      then: (schema) =>
        schema.required(t('required')).notOneOf(['null']).nullable(),
      otherwise: (schema) => schema.nullable()
    }),
    industries: Yup.array(),
    location: Yup.object({
      id: Yup.number().required(t('required')),
      display_name: Yup.string().required(t('required'))
    }),
    contract: Yup.array().required(t('required')),
    default_lang: Yup.number(),
    remote_only: Yup.boolean()
  });
};

export { initialValues, validationSchema };
